import { Navigate, useSearchParams } from 'react-router-dom'
import { useAppStore } from '@/store/useAppStore'
import { ROUTES } from '@shared/config/routes'
import type { ReactNode } from 'react'

interface Props { children: ReactNode }

/** Если юзер уже авторизован — редирект в приложение (или по ?redirect=). */
export const PublicRoute = ({ children }: Props) => {
  const isAuthenticated = useAppStore((s) => s.isAuthenticated)
  const [params] = useSearchParams()

  if (isAuthenticated) {
    const redirect = params.get('redirect') || ROUTES.HOME
    return <Navigate to={redirect} replace />
  }
  return <>{children}</>
}
